module.exports = __webpack_public_path__ + "media/38.7af49a8a.wav";